angular.module('tgaAdmin').controller('SettingsController', [
  '$scope',
  '$state',
  '$timeout',
  'settingsService',
  'SSOProviderService',
  'domainService',
  'envService',
  '$translate',
  'constants',
  'userService',
  '$document',
  function (
    $scope,
    $state,
    $timeout,
    settingsService,
    SSOProviderService,
    domainService,
    envService,
    $translate,
    constants,
    userService,
    $document,
  ) {
    $scope.data = {
      alerts: [],
      isGeneratingLTI: false,
      domain: domainService.domain,
      domain_id: null,
      base: domainService.base,
      slack_client_id: envService.read('slack_client_id'),
      countries: constants.countries.map((c) => c.name),
      isSuperAdmin: userService.checkUserType(['super_admin']),
    };

    $scope.viewmodel = {
      settings: {},
      SSOProviders: [],
      sso_provider_id: null,
      processingAIRequest: false,
    };

    $scope.initialize = function () {
      settingsService.getSettings().then((settings) => {
        domainService.getDomain().then((domain) => {
          $scope.viewmodel.settings = settings;
          $scope.viewmodel.docebo_pub_key = domain.docebo_pub_key;
          $scope.viewmodel.settings.docebo_client_app_id = domain.docebo_client_app_id;
          $scope.viewmodel.settings.docebo_sa_id = domain.docebo_sa_id;
          $scope.viewmodel.settings.docebo_subdomain = domain.docebo_subdomain;
          $scope.viewmodel.sso_provider_id = domain.sso_provider_id;
          $scope.data.domain_id = domain.domain_id;
        });
      });

      SSOProviderService.getSSOProviders().then((SSOProviders) => {
        $scope.viewmodel.SSOProviders = SSOProviders;
      });
    };

    $scope.checkImage = function (image, autoSave) {
      // console.log(image)
      $scope.data.alerts = [];

      if (!image) {
        $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
        return;
      }

      const extension = /(?:\.([^.]+))?$/;
      const ext = extension.exec(image.filename)[1];
      const allowed = /png/i;
      if (!allowed.test(ext)) {
        image.base64 = null;
        $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
        return;
      }

      // Don't allow images larger than 5MB.
      if (image.filesize > 5242880) {
        image.base64 = null;
        $scope.actions.createAlert(
          '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
          'danger',
        );
        return;
      }

      if (autoSave) {
        $scope.actions.submit(autoSave);
      }
    };

    $scope.actions = {
      submit(form) {
        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;

        domainService.updateSso({ sso_provider_id: $scope.viewmodel.sso_provider_id }).then(
          () => {
            settingsService.updateSettings($scope.viewmodel.settings).then(
              (settings) => {
                domainService.getDomain().then((domain) => {
                  $scope.viewmodel.settings = settings;
                  $scope.viewmodel.settings.docebo_client_app_id = domain.docebo_client_app_id;
                  $scope.viewmodel.settings.docebo_sa_id = domain.docebo_sa_id;
                  $scope.viewmodel.settings.docebo_subdomain = domain.docebo_subdomain;
                  $scope.viewmodel.sso_provider_id = domain.sso_provider_id;
                  $scope.actions.createAlert('<span class="fa fa-check"></span> Settings updated.', 'success');
                  form.processing = false;
                  $scope.$emit('refreshSettings', true);
                });
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                form.processing = false;
              },
            );
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      generateLTI() {
        const data = {
          consumer_key: uuidv4(),
          secret: uuidv4(),
        };

        $scope.data.isGeneratingLTI = true;

        settingsService.generateLTI(data).then((settings) => {
          $scope.data.isGeneratingLTI = false;
          $scope.viewmodel.settings = settings;
        });
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      downloadDoceboPubKey() {
        const element = $document[0].createElement('a');
        element.setAttribute(
          'href',
          `data:text/plain;charset=utf-8,${encodeURIComponent($scope.viewmodel.docebo_pub_key)}`,
        );
        element.setAttribute('download', `${domainService.domain}_docebo_pub_key.pub`);
        element.style.display = 'none';
        $document[0].body.appendChild(element);
        element.click();
        $document[0].body.removeChild(element);
      },
      toggleAIFeatures(val) {
        $scope.viewmodel.processingAIRequest = true;
        domainService
          .enableAIFeatures({
            domain_id: $scope.data.domain_id,
            enable_openai_features: val,
          })
          .then(() => {
            settingsService.destroy();
            settingsService.getSettings().then((settings) => {
              domainService
                .getDomainSettings($scope.data.domain_id)
                .then((domainSettings) => {
                  if ($scope.viewmodel.settings.enable_openai_features) {
                    delete $scope.viewmodel.settings.enable_openai_features;
                  }
                  $scope.viewmodel.settings = {
                    ...$scope.viewmodel.settings,
                    ...settings,
                    ...domainSettings,
                    ...(val && { enable_openai_features: 'true' }),
                  };
                })
                .finally(() => {
                  $scope.viewmodel.processingAIRequest = false;
                });
            });
          });
      },
    };
    $scope.initialize();
  },
]);
